import UrlGeneratorService from '../UrlGeneratorService';

import type { KnowledgeBaseService as KnowledgeBaseServiceType } from './types';

const open = (utmCampaign?: string, utmMedium?: string, utmSource?: string) => {
  window.open(UrlGeneratorService.knowledgeBase(utmCampaign, utmMedium, utmSource), '_blank');
};

const getUrl = (utmCampaign?: string, utmMedium?: string, utmSource?: string) =>
  UrlGeneratorService.knowledgeBase(utmCampaign, utmMedium, utmSource);

const openContactForm = () => {
  window.open(UrlGeneratorService.generalKnowledgeBaseTicketForm(), '_blank');
};

const getContactFormUrl = () => UrlGeneratorService.generalKnowledgeBaseTicketForm();

const KnowledgeBaseService: KnowledgeBaseServiceType = {
  open,
  getUrl,
  openContactForm,
  getContactFormUrl,
};

export default KnowledgeBaseService;
